import React from 'react'
import Logo from "/assets/images/swayamRiskLogoBlue.png";
import style from "./wordFromYou.module.css";
import Bg from "/assets/PdfNew/pgbg16.png";
import FeedbackButton from "/assets/PdfNew/feedbackButton.png";

const WordFromYou = () => {
    return (
        <div className={style.wordFromYouOptionBg}>
            {/* Background */}
            <img src={Bg} alt="background" className={style.wordFromYouOptionBg} />

            {/* Logo */}
            <img src={Logo} alt="logo" className={style.logo} />


            {/* Content */}
            <div className={style.content}>
                <p className={style.title}>
                    <strong>We Would Love To Hear From You</strong>
                </p>
                <br></br>
                <p >
                    You just did something truly meaningful — you took the time to understand yourself,
                    explore your strengths, and discover careers that are genuinely aligned to who you are.

                    That is not a small thing. Most people spend years figuring this out. You just got a head start.
                                        <br></br>

                    We'd love to hear about your experience. Was this assessment helpful? Did any of the insights surprise you?
    Please share your thoughts by visiting the Feedback page from the left-hand menu within the SwayamRise platform. Your feedback helps us continuously 
	improve the experience for students and parents.

                    <br></br>

                    Go ahead, share your feedback — we are listening.
                    <br></br>
                                        <br></br>


                    <strong>
                        The SwayamRise Team
                    </strong>

                </p >

            </div>
            {/* <a
          
  href={ `${import.meta.env.VITE_UI_URL}feedback`}
  target='blank'
>
  <img
    src={FeedbackButton}
    alt="feedback"
    className={style.FeedbackButton}
        style={{ cursor: "pointer" }}

  />
</a> */}

        </div>)
}

export default WordFromYou